export const replaceObjectInArray = (array, targetUuid, newElement) => {
  return array.map(item => {
    if (item.member && item.member.uuid === targetUuid) {
      return newElement
    }
    return item
  })
}
